import { render } from "./CZLastAcutalMeterReadWater.vue?vue&type=template&id=5fbcf229&scoped=true&ts=true"
import script from "./CZLastAcutalMeterReadWater.vue?vue&type=script&lang=ts"
export * from "./CZLastAcutalMeterReadWater.vue?vue&type=script&lang=ts"

import "./CZLastAcutalMeterReadWater.vue?vue&type=style&index=0&id=5fbcf229&scoped=true&lang=css"

import exportComponent from "C:\\Devlop\\C-Zone-v1\\UI_EICPartnership\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbcf229"]])

export default __exports__